<template>
  <footer class=" footer-c" v-show="showFooter">
    <div class="container">
      <div class="buttons  mb-half" :class="{'is-centered': isCentered}">
        <!-- LOCALE TOGGLE -->
        <div
          class="button is-small"
          :class="{ 'is-link': $i18n.locale === 'tr'}"
          @click="$root.$i18n.locale = 'tr'"
        >TR</div>
        <div
          class="button is-small"
          :class="{ 'is-link': $i18n.locale === 'en'}"
          @click="$root.$i18n.locale = 'en'"
        >EN</div>
      </div>
      <!-- ./LOCALE TOGGLE -->

      <div class="content " :class="{'has-text-centered': isCentered}">
        <p class="is-size-7" style="margin-bottom: 4px;">
          <router-link :to="{ name: 'faq'}">{{$t('ui.faq')}}</router-link>
          <router-link :to="{ name: 'help'}">
            <span class="has-text-grey" aria-hidden="true">&nbsp;·</span>
            {{$t('ui.termsOfService')}}
          </router-link>
          <router-link :to="{ name: 'help'}">
            <span class="has-text-grey" aria-hidden="true">·</span>
            {{$t('ui.privacyPolicy')}}
          </router-link>
        </p>
        <p class="is-size-7">@ 2019 {{$store.state.appName}}. {{$t('ui.allRightsReserved')}}.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    isCentered: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showFooter: true,
    }
  },
 
};
</script>